import { $fetch } from '@/boot/fetch'

// PEG-509: admin endpoints authenticate via the HttpOnly `peg_admin_session`
// cookie, which the browser only attaches on cross-origin requests when
// `credentials: 'include'` is set. All admin calls must pass this flag.
const credentials = 'include'

export default {
  /** PEG-509: Get current admin session context if active */
  getSession() {
    return $fetch.peg('/admin/session/me', {
      silent: true,
      credentials,
    })
  },
  /** PEG-509: Revoke current admin session */
  logout() {
    return $fetch.peg('/admin/session/logout', {
      method: 'POST',
      credentials,
    })
  },
}
